import React, { useState,useEffect,Fragment } from 'react';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import styles from '../../styles/modules/components/SelfServe/multi-sr-creation.module.scss';
import { connect } from 'react-redux';
import { getParamsObjectFromString, getStaticPath } from "../../utils";
import Button from '../common/ui-components/input/Button';
import { getPageURL } from '../../utils/tracking';
import { chatbotClicked } from '../../tracking/segment/footer';
import UIModal from '../common/ui-components/surface/UIModal';
import { QueryForm } from './QueryForm';
import modalStyles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';

import Image from '../common/Image';
import { useRouter } from 'next/router';

interface ReduxStateProps {
    selfserveReducer: any,
    subIssues:any,
}

type Props = ReduxStateProps

const MultiServiceRequestStatus = (props: Props) => {
    const [appRender, setAppRender] = useState<boolean>(false)
    const router = useRouter()
    useEffect(() => {
        // tacker add here
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});
        
        if(getParamsObjectFromString(window.location.href)['urlParams']['app_render'] === "true"){
            setAppRender(true)
          }

    }, [])
    const srInfoList = props.selfserveReducer.sucessData.sr_details

    const [open, changeOpen] = useState(false);


    const raiseQuery = () => {
        changeOpen(true);
    }
    const openChat = () => {
        // chatWithUsModal('SR Failure Page'); //gtm tracking event
        // event.preventDefault()
        changeOpen(false)
        chatbotClicked({...getPageURL()})
        window.open(`https://onst.in/4dCuJA`, "noopener,noreferrer")
        window.opener = null
    }

    const close = () => {
        changeOpen(false)
        return false
    }

    const getSrStatus = () => {
      return srInfoList.filter((device) => device.is_valid === false).length < srInfoList.length;
    }
    return (
        <div className={styles.sr_creation}>
            {
              getSrStatus() ? (
                <Fragment>
                  <div className={styles._img}>
                    <Image src={getStaticPath(`/static/images/selfserve/success.png`)} quality={100} alt="Success" width="100" height="100" unoptimized={true} />
                  </div>
                  <h5>Service Request Created Successfully</h5>
                </Fragment>
              )
              :
              (
                <Fragment>
                  <div className={styles._img}>
                    <Image src={getStaticPath(`/static/images/selfserve/failure.png`)} quality={100} alt="Success" width="100" height="100" unoptimized={true} />
                  </div>
                  <h5>Unable to create the service request</h5>
                </Fragment>
              )
            }
            <div className={styles.card_holder}>
                {srInfoList[0].is_valid && <div className={`${styles.sr_details} ${styles.sr_details_card}`}>
                    {/* Personal Details Section */}
                    <div className={`${styles.sr_details_section} ${styles.sr_details_section__left}`}>
                        <h6 className={styles.sr_header}>Personal Details</h6>
                        <p className={styles.details}>{srInfoList[0].data.contact_info.name}</p>
                        <p className={styles.details}>{srInfoList[0].data.contact_info.phone}</p>
                        <p className={styles.details}>{srInfoList[0].data.contact_info.email}</p>
                    </div>
                    {/* Address Section */}
                    <div className={styles.sr_details_section}>
                        <h6 className={styles.sr_header}>Address Info</h6>
                        <p className={styles.details}>{srInfoList[0].data.address_info.address},</p>
                        <p className={styles.details}>{`${srInfoList[0].data.address_info.city}, ${srInfoList[0].data.address_info.state}-${srInfoList[0].data.address_info.pincode}`}</p>
                    </div>
                </div>
                }
                {srInfoList.filter((device) => device.is_valid === true).map((device, index) => {
                    return (
                        <div className={styles.sr_details} key={index}>
                            <div>
                                {device.data.device_model &&
                                    <div className={styles.sr_header}>
                                        {device.data.device_model}
                                    </div>
                                }
                                {device.data && device.data.ticket_creation_ref_id &&
                                    <div><span className={styles.sr_header}>Service Request ID:</span>{device.data.ticket_creation_ref_id}</div>
                                }
                                {(device.data.service_type) &&
                                    <div><span className={styles.sr_header}>Service Type:</span> {device.data.service_type}</div>
                                }
                                {device.data.issue_text &&
                                    <div className={styles.sr_issue_selected}>
                                        <div className={styles.sr_header}>Issues Reported:</div>
                                        <div>
                                            {device.data.issue_text && device.data.issue_text.map((issue) => {
                                                return <div>{issue}</div>
                                            })}
                                        </div>

                                    </div>
                                }
                            </div>
                            
                            <div className={styles.sr_tracker} onClick={() => {
                                if(router?.query?.app_render){
                                    router.query.sr_id = device.data.ticket_creation_ref_id
                                    router.push(router)
                                }
                                else{ 
                                    window.open(device.data.track_your_device, "_blank", "noopener,noreferrer")
                                    window.opener = null
                                }
                    }}>
                                <p className={styles.sr_tracker__text}>Track Request</p>
                            </div>
                        </div>)
                })}
            </div>

            {srInfoList.filter((device) => device.is_valid === false).length !== 0 &&
                <div className={styles.card_holder}>
                    <div>
                        <h6 className={styles.sr_failure}>Unable to create the service request</h6>
                        {
                            srInfoList.filter((device) => device.is_valid == false).map((device, index) => {
                                return (
                                    <div className={styles.sr_details} key={index}>

                                        <div>
                                            {device.data.device_model &&
                                                <div className={styles.sr_header}>
                                                    {device.data.device_model}
                                                </div>
                                            }
                                            {device.data && device.data.serial_no &&
                                                <div><span className={styles.sr_header}>Serial No:</span>{device.data.serial_no}</div>
                                            }
                                            {device.error &&
                                                <div className={styles.sr_issue_selected}>
                                                    <div className={styles.sr_header}>Issues Reported:</div>
                                                    <div>
                                                        {device.error.map((reason, i) => {
                                                            return <div key={i}>{reason}</div>
                                                        })}
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </div>)
                            })
                        }

                        <div className={commonStyles.button_actions_sticky} data-varient='sticky' id="bottom-sticky-header">
                            <Button
                                text="Raise Query"
                                onClick={() => raiseQuery()}
                                className={commonStyles.cart_btn}
                                variant="secondary"
                            />
                            <Button
                                text="Chat with us"
                                onClick={openChat}
                                className={commonStyles.cart_btn}
                            />
                        </div>
                    </div>
                </div>
            }
            {open &&
                <UIModal isOpen={open} onClick={close} boxClass={modalStyles.apply_box} larger={false}>
                    <div>
                        <QueryForm onClose={close} subIssues={props.subIssues} />
                    </div>
                </UIModal>
            }
        </div>


    )

}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect(mapStateToProps)(MultiServiceRequestStatus);
